// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1bd39328","667":"30547b06","977":"fa6cc9a6"}[chunkId] + ".chunk.js";
};